import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
interface CommonTooltipProps {
    popoverTitle?: string;
    popoverContent?: string;
    tooltipContent?: string;
    trigger?: 'click' | 'hover' | 'focus';
    placement?: 'top' | 'right' | 'bottom' | 'left' | 'auto';
    btnIcon?: any;
}
const CommonTooltip: React.FC<CommonTooltipProps> = ({
    popoverTitle = '',
    popoverContent = '',
    trigger = 'click',
    placement = 'auto',
    btnIcon = ''
}) => {
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <OverlayTrigger
                trigger={trigger}
                placement={placement}
                overlay={
                    <Popover id="popover-basic" className="common_tooltip">
                        <Popover.Header as="h3">{popoverTitle}</Popover.Header>
                        <Popover.Body>{popoverContent}</Popover.Body>
                    </Popover>
                }
            >
                <button className="common_tooltip_btn" onClick={handleShow}>
                    {btnIcon}
                </button>
            </OverlayTrigger>
        </>
    );
};
export default CommonTooltip;